


import { ReactNode } from "react";
import { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";

import Section from "../WBComponents/Section";
import Heading from "../WBComponents/Heading";
import PageRoot from "../WBComponents/PageRoot";
import Row from "../WBComponents/Row";
import Column from "../WBComponents/Column";
import WBIframe from "../WBComponents/WBIframe";
import WBText from "../WBComponents/WBText";
import WBImage from "../WBComponents/WBImage";
import Spacer from "../WBComponents/Spacer";
import Button from "../WBComponents/Button";
import WBContainer from "../WBComponents/WBContainer";
import React from "react";
import { TextAlignLeft, TextAlignCenter, TextAlignRight, TextAlignJustify, AlignLeft, AlignCenterHorizontal, AlignRight, AlignEvenlyHorizontal, AlignBetweenHorizontal, AlignTop, AlignCenterVertical, AlignBottom, AlignEvenlyVertical, AlignBetweenVertical } from "../Icons/AlignmentIcons";
import { AttributeCollection, getNodeComponentAttributeValue, getNodeStyleAttributes } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBComponent } from "../WBComponents/WBComponent";
import NavigationBar from "../WBComponents/NavigationBar";
import WBFooter from "../WBComponents/WBFooter";
import NavigationList from "../WBComponents/NavigationList";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import ImageSlider from "../WBComponents/ImageSlider";
import BusinessDescription from "../WBComponents/BusinessDescription";
import BusinessHours from "../WBComponents/BusinessHours";
import BusinessServices from "../WBComponents/BusinessServices";
import BusinessSocialLinks from "../WBComponents/BusinessSocialLinks";
import BusinessFacilityInformation from "../WBComponents/BusinessFacilityInformation";
import WBVideoPlayer from "../WBComponents/WBVideoPlayer";
import BusinessReviews from "../WBComponents/BusinessReviews";
import BusinessStaff from "../WBComponents/BusinessStaff";
import ImageGrid from "../WBComponents/ImageGrid";

import { GetScreensizeIcon } from "../Icons/ScreenSizeIcons";
import BeforeAndAfter from "../WBComponents/BeforeAndAfter";
import TestComponent from "../WBComponents/TestComponent";
import BusinessProducts from "../WBComponents/BusinessProducts";
import BusinessPhotoGallery from "../WBComponents/BusinessPhotoGallery";
import BusinessMemberships from "../WBComponents/BusinessMemberships";
import BusinessPackages from "../WBComponents/BusinessPackages";
import BusinessDailyDeals from "../WBComponents/BusinessDailyDeals";
import BusinessGiftCards from "../WBComponents/BusinessGiftCards";
import BusinessMap from "../WBComponents/BusinessMap";
import BusinessReviewPercentage from "../WBComponents/BusinessReviewPercentage";
import BusinessMessage from "../WBComponents/BusinessMessage";
import BusinessCall from "../WBComponents/BusinessCall";
import BusinessCart from "../WBComponents/BusinessCart";
import { BottomLeftCornerIcon, BottomRightCornerIcon, TopLeftCornerIcon, TopRightCornerIcon } from "../Icons/CornerIcons";
import BusinessContactLess from "../WBComponents/BusinessContectLess";
import ProductDetails from "../WBComponents/ProductDetials";
import WBHTMLEmbed from "../WBComponents/WBHTMLEmbed";
import MyAccount from "../WBComponents/MyAccount";
import BusinessBookNow from "../WBComponents/BusinessBookNow";
import BusinessClass from "../WBComponents/BusinessClass";
import AnnouncementBar from "../WBComponents/AnnoucmentBar";
import BusinessForm from "../WBComponents/BusinessForm";
import CookieBanner from "../WBComponents/CookieBanner";
import WBAccordion from "../WBComponents/WBAccordion";
import WBPopup from "../WBComponents/WBPopup";
import BusinessLocation from "../WBComponents/BusinessLocation";
import BusinessName from "../WBComponents/BusinessName";
import BusinessLogo from "../WBComponents/BusinessLogo";
import WBTabs from "../WBComponents/WBTabs";
import WBTabContainer from "../WBComponents/WBTabContainer";
import BusinessHero from "../WBComponents/BusinessHero";
import BusinessNickName from "../WBComponents/BusinessNickName";
import BusinessOwnerName from "../WBComponents/BusinessOwnerName";
import WBRichText from "../WBComponents/WBRichText";
import BlogHeading from "../WBComponents/BlogHeading";
import BlogList from "../WBComponents/BlogList";
import BlogSearch from "../WBComponents/BlogSearch";
import DormantBookButton from "../WBComponents/DormantBookButton";

export function createAllWBComponents():WBComponent[]{  
  
  
  return[

    new WBAccordion(),
    new Section(),
    new Column(),
    new Heading(),
    new PageRoot(),
    new Row(),
    new WBText(),
    new WBImage(),
    new Spacer(),
    new Button(),
    new WBContainer(),
    new NavigationBar(),  
    new WBIframe(),
    new WBFooter(),
    new NavigationList(),
    new ImageSlider(),
    new ImageGrid(),
    new WBVideoPlayer(),
    new BeforeAndAfter(),
    new WBHTMLEmbed(),
    new AnnouncementBar(),
    new CookieBanner(),
    new WBPopup(),
    new WBTabs(),
    new WBTabContainer(),
    new WBRichText(),
    new BusinessDescription(),
    new BusinessHours(),
    new BusinessServices(),
    new BusinessSocialLinks(),
    new BusinessFacilityInformation(),
    new BusinessReviews(),
    new BusinessStaff(),
    new TestComponent(),
    new BusinessProducts(),
    new BusinessPhotoGallery(),
    new BusinessMemberships(),
    new BusinessPackages(),
    new BusinessDailyDeals(),
    new BusinessGiftCards(),
    new BusinessMap(),
    new BusinessReviewPercentage(),
    new BusinessMessage(),
    new BusinessCall(),    
    new BusinessContactLess(),
    new BusinessCart(),
    new ProductDetails(),
    new MyAccount(),
    new BusinessBookNow(),
    new BusinessClass(),
    new BusinessForm(),
    new BusinessLocation(),
    new BusinessName(),
    new BusinessLogo(),
    new BusinessHero(),
    new BusinessNickName(),
    new BusinessOwnerName(),
    new BlogHeading(),
    new BlogList(),
    new BlogSearch(),
    new DormantBookButton()
  ];

  }

export enum AttributeInputType{
  Ignore,
  InputFiled,
  URLField,
  ImageField,
  LinkField,
  MeasurementField,
  FourwayMeasurmentField,
  ButtonField,
  EmojiField,
  FlexDirField,
  SelectField,
  RangeSliderField,
  ColorField,
  ColorFieldWithDebounce,
  HieghtAndWidthField,
  ClipPathField,
  AnchorField,//special field for anchor control
  BackgroundImage,
  FontField,
  BorderField,
  AlignmentField,
  LockField,
  ExternalLink, // allows a displaying a link in the component styling pannel (currently used to link over to users socials in vagaro)
  MultiLocation,
  MultiPageSelect,
  ShadowField,
  CSSField,
  HTMLField,
  StarColorField,
  WhiteLabel,
  ServiceCategorySelector,
  ClassCategorySelector,
  Conditional,
  FormSelectField,
  RadioField,
  SingleCheckField,
  DuplicatedPageSelectField,
  MapButtonField,
  TabsField,
  OverlayField,
  BoxModel,
  ProductFilters,
  BlogFilter,
  BlogSettingsButton,
  MembershipSelector,
  PackageSelector,
}
export enum AttributeTargetType{
  Default = 0,
  Style = 1,
  Component = 2
}

export type AttributeRange = {

  min:number,
  max:number,
  step:number,
  unit:string,
  default?:number

}

export class AttributeDefinition{
  label:string;
  attribute:string;
  attKey:string;
  // cssAttribute:string;
  inputType:AttributeInputType;
  options:{label:ReactNode,value:string,toolTip?:string,rawLable?:string}[];
  range:AttributeRange;
  targetType:AttributeTargetType; // weather this affects the styling or the attribute of a layoutObject

  placeHolder:string = "";
  description:string = "";
  icon:ReactNode = null;
  group:string[] = [];
  shouldShow:(layoutNode:AttributeCollection)=>boolean = ()=>true;
  constructor(attribute:string,label:string,overrideAttribute:string,type:AttributeInputType,options:{label:ReactNode,value:string,toolTip?:string}[]=[],range:AttributeRange|null = null,targetType = AttributeTargetType.Default,toolTip:string="",icon=null){

      this.attribute = attribute;
      this.label = label;
      this.attKey = overrideAttribute.length>0?overrideAttribute:attribute;
      this.options = options;
      this.range = range??{min:0,max:1,step:1,unit:"px",default:0};
      this.inputType = type;
      this.targetType = targetType;//default to styling, all the initialization to handle this based on what array it is part of
      this.description = toolTip;
      this.icon = icon;
  }


}

export function CreateRange(min:number = 0,max:number = 100,step:number = 1,unit:string = "",defaultVal:number = 0){
  return {min:0,max:1,step:1,unit:"px",default:0};
}








function CreateAttributeWithExtras(newDefinition:AttributeDefinition,toolTip:string="",group:string[]):AttributeDefinition{
  newDefinition.group = group;
  newDefinition.description = toolTip;
  return newDefinition;

}

/*
  Creates a conditional wrapper for an attribute, this is used to show or hide an attribute based on the value of another attribute.
  Currently only works with component attributes and not styles
*/
export function CreateConditionalAttribute(attribute:string,defToShow:string,validCOnfigurations:{key:string,value:string}[]){

  const newAtt = new AttributeDefinition(attribute,"",defToShow,AttributeInputType.Conditional);

  newAtt.shouldShow = (layoutNode:AttributeCollection)=>{

      for(let i = 0;i<validCOnfigurations.length;i++){
          let val = getNodeComponentAttributeValue(layoutNode,validCOnfigurations[i].key,"");
          if(val===validCOnfigurations[i].value){      
            return true;
          }
      }
 
      return false;

  }

  return newAtt;
}

export function AttributeDefWithTooltip(newDefinition:AttributeDefinition,toolTip:string):AttributeDefinition{
  newDefinition.description = toolTip;
  return newDefinition;

}

export const autoString = "Auto";
export const smallString = "S";
export const mediumString = "M";
export const largeString = "L";

export const sharedComponentAttributes: { [key: string]: AttributeDefinition } = {
  contentSpacing: new AttributeDefinition(
    "panelPadding",
    "Panel Padding",
    "",
    AttributeInputType.MeasurementField,
    [
        { label: autoString, value: "" },
        { label: smallString, value: "12px" },
        { label: mediumString, value: "16px" },
        { label: largeString, value: "24px" }
    ],
    { min: 0, max: 64, step: 1, unit: "px" }
  ),
    panelRadius:  new AttributeDefinition(
      "panelRadius", 
      "Panel Radius",
       "",
       AttributeInputType.MeasurementField, 
       [
        { label: "Auto", value: "" },
        { label: "S", value: "4px" },
        { label: "M", value: "8px" },
        { label: "L", value: "16px" }

       ],
        { min: 0, max: 500, step: 1, unit: "px" }),
    panelSpacing: new AttributeDefinition(
        "panelLayoutPadding", 
        "Panel Spacing", 
        "", 
        AttributeInputType.MeasurementField, 
        [
            { label: autoString, value: "" },
            { label: smallString, value: "12px" },
            { label: mediumString, value: "16px" },
            { label: largeString, value: "24px" }
        ], 
        { min: 0, max: 32, step: 1, unit: "px" }
    ),
    
};


const styleDefinitions = [
    new AttributeDefinition(attributeTypes.lineHeight,"Line Height","",AttributeInputType.MeasurementField,
    [
      {label:autoString,value:""},
      {label:smallString,value:"1em"},
      {label:mediumString,value:"2em"},
      {label:largeString,value:"4em"}
      
  ],{min:0,max:10,step:.1,unit:"em"}),
  new AttributeDefinition(attributeTypes.letterSpacing,"Letter Spacing","",AttributeInputType.MeasurementField,
  [
    {label:autoString,value:""},
    {label:smallString,value:"-.1em"},
    {label:mediumString,value:"0em"},
    {label:largeString,value:".1em"}
    
],{min:-5,max:5,step:.01,unit:"em"}),
new AttributeDefinition(attributeTypes.padding,"Padding","",AttributeInputType.FourwayMeasurmentField,
[
  {label:autoString,value:""},
  {label:smallString,value:"0px"},
  {label:mediumString,value:"20px"},
  {label:largeString,value:"48px"}
  
],{min:0,max:250,step:1,unit:"px"}),



new AttributeDefinition(attributeTypes.margin,"Margin","",AttributeInputType.FourwayMeasurmentField,
[
{label:autoString,value:""},
{label:smallString,value:"0px"},
{label:mediumString,value:"16px"},
{label:largeString,value:"32px"}

],{min:0,max:250,step:1,unit:"px"}),


CreateAttributeWithExtras( new AttributeDefinition(attributeTypes.borderStyle,"Border","",AttributeInputType.BorderField,[
  {label:autoString,value:""},
  {label:"None",value:"none"},
  {label:"Solid",value:"solid"},
  {label:"Dotted",value:"dotted"},
  {label:"Dashed",value:"dashed"},
  {label:"Double",value:"double"},
  {label:"Groove",value:"groove"},
]),"",[attributeTypes.borderWidth,attributeTypes.borderColor]),

new AttributeDefinition(attributeTypes.borderRadius,"Radius","",AttributeInputType.FourwayMeasurmentField,
[
{label:autoString,value:""},
{label:smallString,value:"4px"},
{label:mediumString,value:"12px"},
{label:largeString,value:"48px"}

],{min:0,max:500,step:1,unit:"px"}),

new AttributeDefinition(attributeTypes.borderWidth,"Width","",AttributeInputType.Ignore,
[{label:"Auto",value:""},{label:"S",value:"1px"},{label:"M",value:"2px"},{label:"L",value:"4px"}],{min:0,max:100,step:1,unit:"px",default:2}),
new AttributeDefinition(attributeTypes.borderColor,"Color","",AttributeInputType.Ignore),

new AttributeDefinition(attributeTypes.clipPath,"Shape Design","",AttributeInputType.ClipPathField,
[
{label:"Auto",value:""},
{label:"None",value:"none"},
{label:"Circle",value:"circle(50% at 50% 50%)"},
{label:"Small Circle",value:"circle(30% at 50% 50%)"},
{label:"Triangle",value:"polygon(50% 0%,0% 100%,100% 100%)"},
{label:"Diamond",value:"polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)"},
{label:"Trapezoid",value:"polygon(25% 0%, 75% 0%, 100% 100%, 0% 100%)"},
{label:"Pentagon",value:"polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)"},
{label:"Octagon",value:"polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)"},
{label:"Star",value:"polygon(50% 2.4%, 34.5% 33.8%, 0% 38.8%, 25% 63.1%, 19.1% 97.6%, 50% 81.3%, 80.9% 97.6%, 75% 63.1%, 100% 38.8%, 65.5% 33.8%)"},
{label:"Slant Right",value:"polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)"},
{label:"Slant Left",value:"polygon(0 0, 75% 0, 100% 100%, 25% 100%)"},
{label:"Slant Up",value:"polygon(0% 25%, 0% 100%, 100% 75%, 100% 0%)"},
{label:"Slant Down",value:"polygon(0 0, 100% 25%, 100% 100%, 0 75%)"},
{label:"Lightning",value:"polygon(25% 0%,70% 0%,40% 35%,95% 35%,20% 100%,40% 55%,0% 55%)"},
{label:"Left Arrow",value:"polygon(40% 0%, 40% 20%, 100% 20%, 100% 80%, 40% 80%, 40% 100%, 0% 50%)"},
{label:"Right Arrow",value:"polygon(0% 20%, 60% 20%, 60% 0%, 100% 50%, 60% 100%, 60% 80%, 0% 80%)"},
{label:"Mark",value:"polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%)"},
{label:"Message",value:"polygon(0% 0%, 100% 0%, 100% 75%, 75% 75%, 75% 100%, 50% 75%, 0% 75%)"},
{label:"Checkered",value:"polygon(0% 0%, 100% 0%, 100% 25%, 0% 25%, 0% 50%, 100% 50%, 100% 75%, 0% 75%, 0% 100%, 100% 100%, 100% 0%, 75% 0%, 75% 100%, 50% 100%, 50% 0%, 25% 0%, 25% 100%, 0% 100%)"},
{label:"Checkered Small",value:"polygon(0% 0%, 10% 0%, 10% 100%, 20% 100%, 20% 0%, 30% 0%, 30% 100%, 40% 100%, 40% 0%, 50% 0%, 50% 100%, 60% 100%, 60% 0%, 70% 0%, 70% 100%, 80% 100%, 80% 0%, 90% 0%, 90% 100%, 100% 100%, 100% 0%, 100% 10%, 0% 10%, 0% 20%, 100% 20%, 100% 30%, 0% 30%, 0% 40%, 100% 40%, 100% 50%, 0% 50%, 0% 60%, 100% 60%, 100% 70%, 0% 70%, 0% 80%, 100% 80%, 100% 90%, 0% 90%, 0% 100%)"},
{label:"Wave",value:"polygon(-1% 100.5%, 0% 50%, 2% 52.4958%, 4% 54.9667%, 6% 57.388%, 8% 59.7355%, 10% 61.9856%, 12% 64.1161%, 14% 66.1054%, 16% 67.9339%, 18% 69.5832%, 20% 71.0368%, 22% 72.2802%, 24% 73.301%, 26% 74.089%, 28% 74.6362%, 30% 74.9374%, 32% 74.9893%, 34% 74.7916%, 36% 74.3462%, 38% 73.6575%, 40% 72.7324%, 42% 71.5802%, 44% 70.2124%, 46% 68.6426%, 48% 66.8866%, 50% 64.9618%, 52% 62.8875%, 54% 60.6845%, 56% 58.3747%, 58% 55.9812%, 60% 53.528%, 62% 51.0395%, 64% 48.5406%, 66% 46.0564%, 68% 43.6115%, 70% 41.2304%, 72% 38.937%, 74% 36.7541%, 76% 34.7036%, 78% 32.8058%, 80% 31.0799%, 82% 29.5431%, 84% 28.2106%, 86% 27.0959%, 88% 26.2099%, 90% 25.5617%, 92% 25.1577%, 94% 25.0019%, 96% 25.0959%, 98% 25.4387%, 100% 26.0269%, 101% 100.5%)"},
{label:"Wave Inverted",value:"polygon(-1% -0.5%, 0% 50%, 2% 47.5042%, 4% 45.0333%, 6% 42.612%, 8% 40.2645%, 10% 38.0144%, 12% 35.8839%, 14% 33.8946%, 16% 32.0661%, 18% 30.4168%, 20% 28.9632%, 22% 27.7198%, 24% 26.699%, 26% 25.911%, 28% 25.3638%, 30% 25.0626%, 32% 25.0107%, 34% 25.2084%, 36% 25.6538%, 38% 26.3425%, 40% 27.2676%, 42% 28.4198%, 44% 29.7876%, 46% 31.3574%, 48% 33.1134%, 50% 35.0382%, 52% 37.1125%, 54% 39.3155%, 56% 41.6253%, 58% 44.0188%, 60% 46.472%, 62% 48.9605%, 64% 51.4594%, 66% 53.9436%, 68% 56.3885%, 70% 58.7696%, 72% 61.063%, 74% 63.2459%, 76% 65.2964%, 78% 67.1942%, 80% 68.9201%, 82% 70.4569%, 84% 71.7894%, 86% 72.9041%, 88% 73.7901%, 90% 74.4383%, 92% 74.8423%, 94% 74.9981%, 96% 74.9041%, 98% 74.5613%, 100% 73.9731%, 101% -0.5%)"},
{label:<div className="flex-row gap-med">
  <svg style={{height:"1.5em"}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" height="1em"><path d="M.6 217.4l.1-.5c.1-.4 .2-1 .4-1.7c.3-1.5 .8-3.4 1.4-5.9c1.2-4.9 3.1-11.8 5.7-20C13.4 173 21.7 151 34 128.6C57.8 85.2 102.2 32 176 32c59 0 96.9 33.6 121.9 75.4c23.6 39.5 38.5 90.8 52 137c.2 .8 .5 1.6 .7 2.4c.3 1 .6 2 .9 2.9c-13.1 17.1-23.1 36.6-29.4 57.1c-6.7 21.6 3.4 42.7 20 53.3c-6 3.8-11.2 9.1-15.1 15.2c-15.4-33.9-26.6-72.5-37-108.1c-.2-.8-.5-1.6-.7-2.4C274.9 215.8 262 172.2 243 140.4c-17.9-30-38-44.4-67-44.4c-38.2 0-65.8 26.8-86 63.4C80.3 177 73.6 195 69.2 208.7c-2.1 6.8-3.6 12.4-4.6 16.2c-.5 1.9-.8 3.4-1 4.3l-.2 1 0 .1c-3.5 17.3-20.4 28.6-37.7 25.1S-2.9 235 .6 217.7l0-.1 0-.2zM353 316.1c3.2-10.6 7.7-21 13.5-31s12.6-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.5 22.5-12.9l0-30.4c0-7 4.5-13.3 11.3-14.8l0-.1c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c8 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.8-2.7 18.4 2.4c7.6 8.1 14.4 17.2 20.1 27.2s10.2 20.4 13.5 31c2 6.7-1.1 13.7-7.2 17.2l-25 14.4c.5 4.1 .7 8.1 .7 12.3s-.3 8.3-.7 12.3l25 14.4c6.1 3.5 9.3 10.5 7.2 17.2c-3.2 10.6-7.7 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.4 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.4 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.5-15.6-7.8-22.5-12.9l-24.7 14.3c-6 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.4-17.2-20.1-27.2s-10.2-20.4-13.5-31c-2-6.7 1.1-13.7 7.2-17.2L385 372.4c-.5-4.1-.7-8.2-.7-12.4s.3-8.3 .7-12.4l-24.8-14.3c-6.1-3.5-9.3-10.5-7.2-17.2zM454.8 336c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24z"></path></svg>
  Custom Wave</div>,value:"generate-wave"}
]),




new AttributeDefinition(attributeTypes.fontSize,"Font Size","",AttributeInputType.MeasurementField,
[
{label:autoString,value:""},
{label:smallString,value:".6em"},
{label:mediumString,value:"1em"},
{label:largeString,value:"1.4em"}

],{min:.1,max:30,step:.1,unit:"em",default:1}),


new AttributeDefinition(attributeTypes.fontFamily,"Font","",AttributeInputType.FontField),

new AttributeDefinition(attributeTypes.textAlign,"Text Align","",AttributeInputType.ButtonField,
[
{label:autoString,value:""},
{label:<TextAlignLeft/>,value:"left"},
{label:<TextAlignCenter/>,value:"center"},
{label:<TextAlignRight/>,value:"right"},
{label:<TextAlignJustify/>,value:"justify"}

]),




new AttributeDefinition(attributeTypes.boxShadow,"Shadow","",AttributeInputType.ShadowField,
[
{label:autoString,value:""},

{label:"S",value:"0px 2px 16px 6px #00000044"},
{label:"M",value:"0px 3px 32px 8px #00000066"},
{label:"L",value:"0px 4px 48px 12px #00000088"},


]),
new AttributeDefinition(attributeTypes.textShadow,"Text Shadow","",AttributeInputType.ShadowField,
[
{label:autoString,value:""},

{label:"S",value:"0 0 8px #00000044"},
{label:"M",value:"0 0 8px #00000066"},
{label:"L",value:"0 0 8px #00000088"},


]),
new AttributeDefinition(attributeTypes.textTransform,"Text Case","",AttributeInputType.SelectField,
[
{label:autoString,value:""},
{label:"Off",value:"none"},
{label:"Capitalize",value:"capitalize"},
{label:"Uppercase",value:"uppercase"},
{label:"Lowercase",value:"lowercase"},


]),

new AttributeDefinition(attributeTypes.fontWeight,"Font Weight","",AttributeInputType.SelectField,
[

{label:autoString,value:""},
{label:"Thin",value:"100"},
{label:"Extra Light",value:"200"},
{label:"Light",value:"300"},
{label:"Regular",value:"400"},
{label:"Medium",value:"500"},
{label:"Semi-Bold",value:"600"},
{label:"Bold",value:"700"},
{label:"Extra-Bold",value:"800"},
{label:"Heavy",value:"900"},


],{min:0,max:10,step:.1,unit:"em"}),


new AttributeDefinition(attributeTypes.blendMode,"Blend Mode","",AttributeInputType.SelectField,
[

{label:autoString,value:""},
  { label: "Normal", value: "normal" },
  { label: "None", value: "none" },
  { label: "Multiply", value: "multiply" },
  { label: "Screen", value: "screen" },
  { label: "Overlay", value: "overlay" },
  { label: "Darken", value: "darken" },
  { label: "Lighten", value: "lighten" },
  { label: "Color Dodge", value: "color-dodge" },
  { label: "Color Burn", value: "color-burn" },
  { label: "Hard Light", value: "hard-light" },
  { label: "Soft Light", value: "soft-light" },
  { label: "Difference", value: "difference" },
  { label: "Exclusion", value: "exclusion" },
  { label: "Hue", value: "hue" },
  { label: "Saturation", value: "saturation" },
  { label: "Color", value: "color" },
  { label: "Luminosity", value: "luminosity" }
]),

new AttributeDefinition(attributeTypes.textDecoration,"Text Format","",AttributeInputType.SelectField,
[

{label:autoString,value:""},
{ label: "None", value: "none" },
{ label: "Underline", value: "underline" },
{ label: "Line Through", value: "line-through" },


]),

new AttributeDefinition("textVertical","Vertical Align",attributeTypes.alignContent,AttributeInputType.ButtonField,
  [
  
  {label:autoString,value:""},
  { label: <AlignTop/>, value: "flex-start" },
  { label: <AlignCenterVertical/>, value: "center" },
  { label: <AlignBottom/>, value: "flex-end" },
  
  
  ]),

new AttributeDefinition(attributeTypes.flexBias,"Expand to Content","",AttributeInputType.ButtonField,
[
  {label:autoString,value:""},
  {label:"Expand",value:"auto"},
  {label:"Don't Expand",value:"0"},
]),
new AttributeDefinition(attributeTypes.flexGrow,"Proportion","",AttributeInputType.MeasurementField,
[
{label:autoString,value:""},
{label:"1:1",value:"1"},
{label:"2:1",value:"2"},
{label:"3:1",value:"3"}

],{min:0,max:12,step:.05,unit:"",default:1}),
new AttributeDefinition(attributeTypes.opacity,"Opacity","",AttributeInputType.RangeSliderField,
[


],{min:0,max:1,step:.01,unit:"",default:1}),
new AttributeDefinition(attributeTypes.flexDirection,"Content Order","",AttributeInputType.Ignore,
[
  {label:autoString,value:""},
  {label:"Horizontal",value:"row"},

  {label:"Vertical",value:"column"},


  

]),
new AttributeDefinition(attributeTypes.position,"Positioning","",AttributeInputType.Ignore,
[
   {label:autoString,value:""},
  {label:"Normal",value:"initial"},
  {label:"Absolute",value:"absolute"},

]),

new AttributeDefinition(attributeTypes.zIndex,"Z Index","",AttributeInputType.Ignore),

// new AttributeDefinition(attributeTypes.display,"Visibility","",AttributeInputType.HideField,
// [
//   {label:autoString,value:""},
//   {label:"Visible",value:" "},
//   {label:"Hidden",value:"none"},

  

// ]),
new AttributeDefinition(attributeTypes.flexWrap,"Wrap Content","",AttributeInputType.ButtonField,
[
  {label:autoString,value:""},
  {label:"None",value:"nowrap"},
  {label:"Wrap",value:"wrap"},

  

]),

new AttributeDefinition(attributeTypes.overflow,"Overflow","",AttributeInputType.SelectField,[
  {label:autoString,value:""},
  {label:"Scroll",value:"auto"},
  {label:"Show",value:"visible"},
  {label:"Hide",value:"hidden"},
  


]),

// new AttributeDefinition(attributeTypes.justifyContent,"Horizontal Align","",AttributeInputType.ButtonField,
// [
//   {label:"Align Left"><AlignLeft/>,value:"flex-start"},
//   {label:"Align Center"><AlignCenterHorizontal/>,value:"center"},
//   {label:"Align Right"><AlignRight/>,value:"flex-end"},
//   {label:"Align Evenly"><AlignEvenlyHorizontal/>,value:"space-evenly"},
//   {label:"Align Between"><AlignBetweenHorizontal/>,value:"space-between"},

// ]),

new AttributeDefinition(attributeTypes.gap,"Spacing","",AttributeInputType.MeasurementField,
[
{label:autoString,value:""},
{label:smallString,value:"4px"},
{label:mediumString,value:"10px"},
{label:largeString,value:"24px"}

],{min:0,max:500,step:1,unit:"px"}),

new AttributeDefinition(attributeTypes.backgroundColor,"Background Color","",AttributeInputType.ColorField),

CreateAttributeWithExtras( 
new AttributeDefinition(attributeTypes.backgroundImage,"Background Image","",AttributeInputType.BackgroundImage),"",
[attributeTypes.backgroundSize,attributeTypes.backgroundRepeat,attributeTypes.backgroundAttachment]),

new AttributeDefinition(attributeTypes.backgroundPosition,"Background Position","",AttributeInputType.Ignore,
[
{label:autoString,value:""},
{label:"Center",value:"center"},
{label:"Left",value:"left"},
{label:"Right",value:"right"},
{label:"Top",value:"top"},
{label:"Bottom",value:"bottom"},


]),
new AttributeDefinition(attributeTypes.objectPosition,"Image Position","",AttributeInputType.SelectField,
[
{label:autoString,value:""},
{label:"Center",value:"center"},
{label:"Left",value:"left"},
{label:"Right",value:"right"},
{label:"Top",value:"top"},
{label:"Bottom",value:"bottom"},


]),

new AttributeDefinition(attributeTypes.backgroundRepeat,"Background Repeat","",AttributeInputType.Ignore,
[
{label:autoString,value:""},
{label:"None",value:"no-repeat"},
{label:"Repeat",value:"repeat"},

]),
new AttributeDefinition(attributeTypes.backgroundSize,"Background Size","",AttributeInputType.Ignore,
[
{label:autoString,value:""},
{label:"Cover",value:"cover"},
{label:"Contain",value:"contain"},

]),

new AttributeDefinition(attributeTypes.backgroundAttachment,"Parallax Background","",AttributeInputType.Ignore,
[
{label:autoString,value:""},
{label:"Off",value:"initial"},
{label:"On",value:"fixed"},

]),

new AttributeDefinition(attributeTypes.objectFit,"Image Fit","",AttributeInputType.SelectField,
[
{label:autoString,value:""},
{label:"none",value:"none"},
{label:"Fill",value:"fill"},
{label:"Contain",value:"contain"},
{label:"Cover",value:"cover"},


],null,AttributeTargetType.Style,"How this Component fills a container"),

new AttributeDefinition("justifyVertical","Vertical Align",attributeTypes.justifyContent,AttributeInputType.Ignore,
[
  {label:"Auto",value:""},
  {label:<AlignTop/>,value:"flex-start",toolTip:"Align Top"},
  {label:<AlignCenterVertical/>,value:"center",toolTip:"Align Center"},
  {label:<AlignBottom/>,value:"flex-end",toolTip:"Align Bottom"},
  {label:<AlignEvenlyVertical/>,value:"space-evenly",toolTip:"Space Evenly"},
  {label:<AlignBetweenVertical/>,value:"space-between",toolTip:"Space Between"},
 
]),
new AttributeDefinition("alignVertical","Vertical Align",attributeTypes.alignContent,AttributeInputType.Ignore,
[
  {label:"Auto",value:""},
  {label:<AlignTop/>,value:"flex-start"},
  {label:<AlignCenterVertical/>,value:"center"},
  {label:<AlignBottom/>,value:"flex-end"},
  {label:<AlignEvenlyVertical/>,value:"space-evenly",toolTip:"Space Evenly"},
  {label:<AlignBetweenVertical/>,value:"space-between"},
 
]),
new AttributeDefinition("alignHorizontal","Horizontal Align",attributeTypes.alignContent,AttributeInputType.Ignore,
[
  {label:"Auto",value:""},
  {label:<AlignLeft/>,value:"flex-start",toolTip:"Align Left"},
  {label:<AlignCenterHorizontal/>,value:"center",toolTip:"Align Center"},
  {label:<AlignRight/>,value:"flex-end",toolTip:"Align Right"},
  {label:<AlignEvenlyHorizontal/>,value:"space-evenly",toolTip:"Space Evenly"},
  {label:<AlignBetweenHorizontal/>,value:"space-between", toolTip:"Space Between"},

]),
new AttributeDefinition("justifyHorizontal","Horizontal Align",attributeTypes.justifyContent,AttributeInputType.Ignore,
[
  {label:"Auto",value:""},
  {label:<AlignLeft/>,value:"flex-start",toolTip:"Align Left"},
  {label:<AlignCenterHorizontal/>,value:"center",toolTip:"Align Center"},
  {label:<AlignRight/>,value:"flex-end",toolTip:"Align Right"},
  {label:<AlignEvenlyHorizontal/>,value:"space-evenly",toolTip:"Space Evenly"},
  {label:<AlignBetweenHorizontal/>,value:"space-between", toolTip:"Space Between"},

]),
new AttributeDefinition("alignment-full","Alignment","",AttributeInputType.AlignmentField),

new AttributeDefinition(attributeTypes.justifyContent,"","",AttributeInputType.Ignore),
new AttributeDefinition(attributeTypes.alignItems,"","",AttributeInputType.Ignore),

new AttributeDefinition(attributeTypes.color,"Font Color","",AttributeInputType.ColorField),

new AttributeDefinition(attributeTypes.width,"Width","",AttributeInputType.Ignore),
new AttributeDefinition("minWidth","Width","",AttributeInputType.Ignore),
new AttributeDefinition("maxWidth","Width","",AttributeInputType.Ignore),

new AttributeDefinition(attributeTypes.height,"height","",AttributeInputType.Ignore),
new AttributeDefinition("minHeight","height","",AttributeInputType.Ignore),
new AttributeDefinition("maxHeight","height","",AttributeInputType.Ignore),
new AttributeDefinition("left","left","",AttributeInputType.Ignore),
new AttributeDefinition("top","top","",AttributeInputType.Ignore),
new AttributeDefinition("right","right","",AttributeInputType.Ignore),
new AttributeDefinition("bottom","bottom","",AttributeInputType.Ignore),
new AttributeDefinition(attributeTypes.alignContent,"bottom","",AttributeInputType.Ignore),
new AttributeDefinition(attributeTypes.alignItems,"bottom","",AttributeInputType.Ignore),
new AttributeDefinition("posAnchor","Anchor","position",AttributeInputType.AnchorField),

];





///END STLE ATTRIBUTE DEFINITIONS













const headerSizingRange = {min:2,max:100,step:1,unit:"px"}



const componentAttributeDefinitions:AttributeDefinition[] = [

  new AttributeDefinition("imageSrc","Image","",AttributeInputType.InputFiled),

  new AttributeDefinition(componentAttributeTypes.customCSS,"Custom CSS","",AttributeInputType.CSSField),
  new AttributeDefinition("starColor","Star Color (Global)","",AttributeInputType.StarColorField),
  new AttributeDefinition(componentAttributeTypes.visibility,"Device Visibility","",AttributeInputType.SelectField,
  [
    {label:<GetScreenSizeVisibilityLable setKey="a" desktopVisible = {true} tabletVisible={true} mobileVisibile={true} />,value:""},
    {label:<GetScreenSizeVisibilityLable setKey="b" desktopVisible = {true} tabletVisible={false} mobileVisibile={false} /> ,value:"show-desktop"},
    {label:<GetScreenSizeVisibilityLable setKey="c" desktopVisible = {true} tabletVisible={true} mobileVisibile={false} />,value:"hide-mobile"},
    {label:<GetScreenSizeVisibilityLable setKey="d" desktopVisible = {false} tabletVisible={true} mobileVisibile={false} />,value:"show-tablet"},
    
    {label:<GetScreenSizeVisibilityLable setKey="e" desktopVisible = {false} tabletVisible={true} mobileVisibile={true} />,value:"hide-desktop"},
    {label:<GetScreenSizeVisibilityLable setKey="f" desktopVisible = {false} tabletVisible={false} mobileVisibile={true} />,value:"show-mobile"},

   
    


  ]
  
  ),
  new AttributeDefinition(componentAttributeTypes.multiLocation,"Location","",AttributeInputType.MultiLocation),
  new AttributeDefinition(componentAttributeTypes.alloWMultiLocalationBooking,"Allow Booking At","",AttributeInputType.Ignore),

  new AttributeDefinition(componentAttributeTypes.locked,"Lock","",AttributeInputType.LockField,
  [


]
  ),

  new AttributeDefinition("anchorType","Offset From","",AttributeInputType.Ignore,
  [
  {label:<TopLeftCornerIcon/>,value:"top-left",toolTip:"Top Left"},
  {label:<TopRightCornerIcon/>,value:"top-right",toolTip:"Top Right"},
  {label:<BottomRightCornerIcon/>,value:"bottom-right",toolTip:"Bottom Right"},
  {label:<BottomLeftCornerIcon/>,value:"bottom-left",toolTip:"Bottom Left"},

]
  ),

  new AttributeDefinition(componentAttributeTypes.animation,"Animation","",AttributeInputType.SelectField,[

    {label:"None",value:""},
    {label:"Fade in",value:"fade-in"},
    {label:"Fade in Left to Right",value:"fade-in-right"},
    {label:"Fade in Right to Left",value:"fade-in-left"},
    {label:"Fade in Bottom to Top",value:"fade-in-up"},
    {label:"Fade in Top to Bottom",value:"fade-in-down"},
    {label:"Grow",value:"grow"},
  ]),
  new AttributeDefinition(componentAttributeTypes.overlayColor,"Background Overlay","",AttributeInputType.OverlayField),
  new AttributeDefinition(componentAttributeTypes.horizontalAlign,"Horizontal Align","",AttributeInputType.ButtonField,
  [
    {label:"Auto",value:""},
    {label:<AlignLeft/>,value:"flex-start",toolTip:"Align Left"},
    {label:<AlignCenterHorizontal/>,value:"center",toolTip:"Align Center"},
    {label:<AlignRight/>,value:"flex-end",toolTip:"Align Right"},
    {label:<AlignEvenlyHorizontal/>,value:"space-evenly",toolTip:"Space Evenly"},
    {label:<AlignBetweenHorizontal/>,value:"space-between", toolTip:"Space Between"},

  ]),
  new AttributeDefinition(componentAttributeTypes.verticalAlign,"Vertical Align","",AttributeInputType.ButtonField,
  [
    {label:"Auto",value:""},
    {label:<AlignTop/>,value:"flex-start",toolTip:"Align Top"},
    {label:<AlignCenterVertical/>,value:"center",toolTip:"Align Center"},
    {label:<AlignBottom/>,value:"flex-end",toolTip:"Align Bottom"},
    {label:<AlignEvenlyVertical/>,value:"space-evenly",toolTip:"Space Evenly"},
    {label:<AlignBetweenVertical/>,value:"space-between",toolTip:"Space Between"},
   
  ]),
  new AttributeDefinition("pageWidth","Page Width (Max)","",AttributeInputType.MeasurementField,
  [
    {label:autoString,value:""},
    {label:smallString,value:"800px"},
    {label:mediumString,value:"1000px"},
    {label:largeString,value:"1200px"}
    
  ],{min:600,max:2000,step:1,unit:"px"}),
  new AttributeDefinition("defaultPadding","Default Padding","",AttributeInputType.MeasurementField,
  [
    {label:autoString,value:""},
    {label:smallString,value:"0px"},
    {label:mediumString,value:"12px"},
    {label:largeString,value:"24px"}
    
  ],{min:0,max:200,step:1,unit:"px"}),

  new AttributeDefinition("pageColor","Background Color","",AttributeInputType.ColorField),
  new AttributeDefinition("pageFontColor","Font Color","",AttributeInputType.ColorField),

  new AttributeDefinition("hSize1","Heading 1","",AttributeInputType.RangeSliderField,
  [ ],headerSizingRange),
  new AttributeDefinition("hSize2","Heading 2","",AttributeInputType.RangeSliderField,
  [ ],headerSizingRange),
  new AttributeDefinition("hSize3","Heading 3","",AttributeInputType.RangeSliderField,
  [ ],headerSizingRange),
  
  new AttributeDefinition("hSize4","Heading 4","",AttributeInputType.RangeSliderField,
  [ ],headerSizingRange),

  new AttributeDefinition("pSize1","Paragraph 1","",AttributeInputType.RangeSliderField,
  [ ],headerSizingRange),
  new AttributeDefinition("pSize2","Paragraph 2","",AttributeInputType.RangeSliderField,
  [ ],headerSizingRange),
  new AttributeDefinition("pSize3","Paragraph 3","",AttributeInputType.RangeSliderField,
  [ ],headerSizingRange),
  


];



function GetScreenSizeVisibilityLable({desktopVisible,tabletVisible,mobileVisibile,setKey}:{desktopVisible:boolean,tabletVisible:boolean,mobileVisibile:boolean,setKey:string}){





  const  RenderScreenSize = ({screenSize,isVisible}:{screenSize:ScreenSize,isVisible:boolean}) =>{

return   <div className="center-all" style={isVisible?{fontSize: "1.5em",height:"1.5em",width:"1em",position:"relative"}:{fontSize: "1.5em",opacity:".25",height:"1.5em",width:"1em",position:"relative"}}>

  {!isVisible&& <div  style={{background:"#333",position:"absolute",transform:"rotateZ(-35deg)",width:"2px",borderRadius:"2px",height:"85%",left:"38%",top:"14%"}}></div>}
  <GetScreensizeIcon screenSize={screenSize} />
</div>

}
// negative margin to compinstate for icons being slightly taller than text
return <div className="flex-row  justify-center gap-small" style={{padding:"0 10px"}}> 
  {[ScreenSize.Desktop,ScreenSize.Tablet,ScreenSize.Mobile].map((screenSize,index)=>{


    return <RenderScreenSize key = {index+setKey} screenSize={screenSize} isVisible={screenSize==ScreenSize.Desktop?desktopVisible:screenSize==ScreenSize.Tablet?tabletVisible:mobileVisibile} />

  })}
</div>

}



export function GetComponentOrStyleValueFromDefinition( definition:AttributeDefinition,layoutObject:AttributeCollection,screenSize:ScreenSize,defaultVal:string = "",replaceSpecail=true){




   switch(definition.targetType){
      case AttributeTargetType.Component:
        return layoutObject.componentAttributes[definition.attKey]??defaultVal;
      case AttributeTargetType.Style:
    
        let style =getNodeStyleAttributes(layoutObject, screenSize);

        
        let val = (!style)?defaultVal:style[definition.attKey]??defaultVal;
      if(replaceSpecail&&val=="^")
        val = defaultVal;

        return val??defaultVal;
      case AttributeTargetType.Default:
        return defaultVal;
      default:
        return defaultVal;
   }
 // return (definition.targetType == AttributeTargetType.Component)?layoutObject.componentAttributes[definition.attribute]??defaultVal:layoutObject.getStyleAttributes(screenSize)[definition.attribute]??defaultVal;

}
  

    



function initAttributeDefinitions(){

  let allWBComponents:WBComponent[] = createAllWBComponents();
    
    //let attributeDefinitions = [];
    let dict:{ [key: string]: AttributeDefinition } = {};
  


  for (let i = 0; i < styleDefinitions.length; i++) {
    if (styleDefinitions[i].targetType === AttributeTargetType.Default)
      styleDefinitions[i].targetType = AttributeTargetType.Style;
    dict[styleDefinitions[i].attribute] = styleDefinitions[i];
  }
  for (let i = 0; i < componentAttributeDefinitions.length; i++) {
    if (componentAttributeDefinitions[i].targetType === AttributeTargetType.Default)
      componentAttributeDefinitions[i].targetType = AttributeTargetType.Component;
    dict[componentAttributeDefinitions[i].attribute] =
      componentAttributeDefinitions[i];
  }

  for (let i = 0; i < allWBComponents.length; i++) {

    let componentDef = allWBComponents[i].getComponentSpecificAttributeDefinitions();
    

    for (let e = 0; e < componentDef.length; e++) {
      if (componentDef[e].targetType === AttributeTargetType.Default){
        componentDef[e].targetType = AttributeTargetType.Component;
      }
      
      dict[componentDef[e].attribute] = componentDef[e];
    }

  }

  //Add tool tips to exisitng atts instead of redefining them all

  dict["altText"].description = "Text will show for screen readers and if image doesn't load."


  dict["altText"].placeHolder = "Text"



  let clipPath = dict[attributeTypes.clipPath];
  let options = clipPath.options;

  for(let i = 2;i<clipPath.options.length;i++){

    if(clipPath.options[i].value != "generate-wave")
    options[i].label = <div className="flex-row gap-med" ><div style={{width:"20px",height:"20px",clipPath:options[i].value,background:"#666"}}></div><span>{options[i].label}</span></div>




  }


  

  return dict;


}

const allDefinitions = initAttributeDefinitions();

export default function GetAttributeDefinition(attribute:string) : AttributeDefinition{


    let definition = allDefinitions[attribute];

    return definition??new AttributeDefinition(attribute,`Missing:${attribute}`,"",AttributeInputType.InputFiled);

}


//Defered instanciation of all the components to avoid circular dependencies
function InitializeWBComponentDictionary(){

  let allWBComponents = createAllWBComponents();

  let dict:{ [id: string] : WBComponent; } = {};
   
  for(let i = 0;i<allWBComponents.length;i++){
    dict[allWBComponents[i].typename] = allWBComponents[i];
  }
  return dict;


}

let wBComponetDictionary:{ [id: string] : WBComponent; }|null;


export const ProductDetailsSlug = "product-details";
export const ProductListSlug = "product-list";
export const subscriptionThankyouSlug = "thank-you";
export const ReservedURLSlugs = [
  ProductDetailsSlug,
  "myaccount",
  "shopping-bag",
  "admin",
  "business",
  "preview",
  "blog-post",
  "blog-search",
  ProductListSlug,
  subscriptionThankyouSlug
];


export  function GetWBComponentByTypename(typename:string){

  if(wBComponetDictionary == null){
    wBComponetDictionary = InitializeWBComponentDictionary();
  }

  let toReturn = wBComponetDictionary[typename];
  if(!toReturn){
    return wBComponetDictionary["container"];
  }
  return toReturn;


  


}
